import React, { useState, useEffect, useMemo, useRef } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css'
import {sdk} from './sdk.js';
import {sdkLocal} from './sdkLocal.js';
import './NotificationRow.css';
import { SocialUserAvatar } from "./SocialUserAvatar.js";
import { SocialPageAvatar } from "./SocialPageAvatar";
import LiberiumLink from './LiberiumLink';
import { FaHeart, FaComment, FaUserFriends, FaShare, FaBell, FaStore } from 'react-icons/fa';
import moment from 'moment';
import 'moment/locale/fr';

// Configure moment to use French locale
moment.locale('fr');

const NotificationRow = ({ notification, isNew = false }) => {
    // Format time nicely
    const formatTimeAgo = (timestamp) => {
        const now = moment();
        const notificationTime = moment.unix(timestamp);
        const diff = now.diff(notificationTime, 'seconds');
        
        if (diff < 60) {
            return 'À l\'instant';
        } else if (diff < 3600) {
            return `${Math.floor(diff / 60)}m`;
        } else if (diff < 86400) {
            return `${Math.floor(diff / 3600)}h`;
        } else if (diff < 604800) {
            return `${Math.floor(diff / 86400)}j`;
        } else {
            return notificationTime.format('DD MMM');
        }
    };

    // Determine notification type icon
    const getNotificationTypeInfo = () => {
        // Check for order_enroute type first
        if (notification.type === 'order_enroute') {
            return { type: 'order', icon: <FaStore size={12} /> };
        }
        
        // Extract notification type from text for other cases
        const text = notification.text.toLowerCase();
        
        if (text.includes('aimé') || text.includes('aime')) {
            return { type: 'like', icon: <FaHeart size={12} /> };
        } else if (text.includes('commenté') || text.includes('commenter')) {
            return { type: 'comment', icon: <FaComment size={12} /> };
        } else if (text.includes('ami') || text.includes('abonné') || text.includes('suivre')) {
            return { type: 'friend', icon: <FaUserFriends size={12} /> };
        } else if (text.includes('partagé') || text.includes('partager')) {
            return { type: 'share', icon: <FaShare size={12} /> };
        } else {
            return { type: 'system', icon: <FaBell size={12} /> };
        }
    };

    const { type, icon } = getNotificationTypeInfo();
    const isUnread = notification.seen === 0;
    const classNames = `notirow-item notirow-type-${type} ${isNew ? 'notirow-new' : ''}`;

    return (
        <LiberiumLink href={notification.url} className={classNames}>
            <div className="notirow-container">
                <div className="notirow-icon-wrapper">
                    {notification.notifier_id > 0 ? (
                        <SocialUserAvatar user_id={notification.notifier_id} className="notirow-avatar" />
                    ) : notification.page_id > 0 ? (
                        <SocialPageAvatar page_id={notification.page_id} className="notirow-avatar" />
                    ) : (
                        <div className="notirow-system-avatar">
                            <FaBell size={24} />
                        </div>
                    )}
                    <div className={`notirow-type-indicator notirow-type-indicator-${type}`}>
                        {icon}
                    </div>
                </div>
                
                <div className="notirow-content">
                    <div className="notirow-header">
                        <p className="notirow-message">
                            {notification.text}
                        </p>
                        {isUnread && (
                            <div className="notirow-status">
                                <div className="notirow-unread-indicator"></div>
                            </div>
                        )}
                    </div>
                    
                    <div className="notirow-meta">
                        <span className="notirow-time">
                            {formatTimeAgo(notification.time)}
                        </span>
                        <span className="notirow-action">
                            Voir les détails
                        </span>
                    </div>
                </div>
            </div>
        </LiberiumLink>
    );
};

export { NotificationRow };